export default function LoanProcess({ badge, title, description, items = [] }) {
  return (
    <section id="process" className="py-20 bg-slate-50">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto text-center">
          <span className="text-primary font-semibold uppercase tracking-wider">
            {badge}
          </span>

          <h2 className="mt-3 text-3xl md:text-4xl font-bold text-slate-900">
            {title}
          </h2>

          <p className="mt-5 text-lg text-slate-600 leading-8">{description}</p>
        </div>

        <div className="relative mt-16">
          {/* Vertical line */}
          <div className="absolute left-6 top-0 bottom-0 w-px bg-slate-300 lg:hidden" />

          {/* Horizontal line */}
          <div className="hidden lg:block absolute top-10 left-0 right-0 h-px bg-slate-300" />

          <div className="grid lg:grid-cols-6 gap-10">
            {items.map((step, index) => {
              const Icon = step.icon;

              return (
                <div key={step.title} className="relative">
                  <div className="flex lg:flex-col items-start lg:items-center">
                    <div className="relative z-10 flex h-14 w-14 items-center justify-center rounded-full bg-primary text-white shadow-lg">
                      <Icon className="h-7 w-7" />
                    </div>

                    <div className="ml-6 lg:ml-0 lg:mt-6 text-left lg:text-center">
                      <div className="inline-flex items-center justify-center rounded-full bg-primary/10 px-3 py-1 text-sm font-semibold text-primary mb-3">
                        Step {index + 1}
                      </div>

                      <h3 className="text-lg font-semibold">{step.title}</h3>

                      <p className="mt-3 text-slate-600 leading-7 text-sm">
                        {step.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
